import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PopoverTrigger, type PopoverTriggerProps, useForwardProps } from 'reka-ui';


export default /*@__PURE__*/_defineComponent({
  __name: 'PopoverTrigger',
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(__props: any) {

const props = __props;
const forwarded = useForwardProps(props);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PopoverTrigger), _normalizeProps(_guardReactiveProps(_unref(forwarded))), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16))
}
}

})